import { Injectable } from '@angular/core';
import { Repository } from '@frontend-site/shared/utils';
import { createStore, select, withProps } from '@ngneat/elf';
import { MainHeaderMenu, MegaMenuColumn, MenuStates } from '../models';
import { createInitialState, MenuState } from '../models/menu-state';

@Injectable()
export class MenuStore extends Repository<MenuState> {
    mainHeaderMenu$ = this.store.pipe(select((p) => p.mainHeaderMenu));
    megaMenuColumns$ = this.store.pipe(select((s) => s.megaMenuColumns));

    get currentMenuState(): MenuStates | undefined {
        return this.getValue().mainHeaderMenu?.state;
    }

    getCurrentMenuEntries(): string[] {
        return this.getValue().mainHeaderMenu?.items?.map((item) => item.id ?? '');
    }

    constructor() {
        super(createStore({ name: 'MenuRepository' }, withProps<MenuState>(createInitialState())));
    }

    setMainHeaderMenu(mainHeaderMenu: MainHeaderMenu): void {
        this.update({ mainHeaderMenu });
    }

    setMegaMenuColumns(megaMenuColumns: MegaMenuColumn[]): void {
        this.update({ megaMenuColumns });
    }
}
